import { render, staticRenderFns } from "./c-homepage.vue?vue&type=template&id=270b7f1a&scoped=true&"
import script from "./c-homepage.vue?vue&type=script&lang=js&"
export * from "./c-homepage.vue?vue&type=script&lang=js&"
import style0 from "./c-homepage.vue?vue&type=style&index=0&id=270b7f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b7f1a",
  null
  
)

export default component.exports